import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from "react";
import { useSelector } from "react-redux";
import { getAttendanceColor } from "helpers/attendance";
import { translate as getTranslate, Icon } from "@haldor/ui";
var ItemContent = function ItemContent(props) {
  var event = props.event,
    lesson = props.lesson,
    attendance = props.attendance;
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
  if (props.view == "month") {
    var _event$length3, _event$length4, _event$length5, _event$length6, _event$length7;
    var getAssignmentExams = function getAssignmentExams() {
      var _event$length$ASSIGNM, _event$length, _event$length$ASSIGNM2, _event$length2;
      return ((_event$length$ASSIGNM = event === null || event === void 0 || (_event$length = event.length) === null || _event$length === void 0 ? void 0 : _event$length.ASSIGNMENT_TYPE_VERBAL_TEST) !== null && _event$length$ASSIGNM !== void 0 ? _event$length$ASSIGNM : 0) + ((_event$length$ASSIGNM2 = event === null || event === void 0 || (_event$length2 = event.length) === null || _event$length2 === void 0 ? void 0 : _event$length2.ASSIGNMENT_TYPE_WRITTEN_TEST) !== null && _event$length$ASSIGNM2 !== void 0 ? _event$length$ASSIGNM2 : 0);
    };
    var getLessons = function getLessons() {
      return event.length.lesson - event.length.lessonExaminations;
    };
    var getAssignemnts = function getAssignemnts() {
      return event.length.assignment - getAssignmentExams();
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "month-event"
    }, /*#__PURE__*/React.createElement("div", {
      className: "month-text"
    }, (event === null || event === void 0 || (_event$length3 = event.length) === null || _event$length3 === void 0 ? void 0 : _event$length3.lessonExaminations) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon examination"
    }), /*#__PURE__*/React.createElement("span", null, event === null || event === void 0 || (_event$length4 = event.length) === null || _event$length4 === void 0 ? void 0 : _event$length4.lessonExaminations, " ", translate('Test (Lessons)'))), getLessons() > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon lesson"
    }), /*#__PURE__*/React.createElement("span", null, getLessons(), " ", translate("Lessons"))), getAssignmentExams() > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon examination"
    }), ' ', /*#__PURE__*/React.createElement("span", null, getAssignmentExams(), " ", translate('Test (Assignments)'))), getAssignemnts() > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon assignment"
    }), " ", /*#__PURE__*/React.createElement("span", null, getAssignemnts(), " ", translate("Assignments"))), (event === null || event === void 0 || (_event$length5 = event.length) === null || _event$length5 === void 0 ? void 0 : _event$length5.meetings) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon meeting"
    }), " ", /*#__PURE__*/React.createElement("span", null, event === null || event === void 0 || (_event$length6 = event.length) === null || _event$length6 === void 0 ? void 0 : _event$length6.meetings, " ", translate("Meetings"))), ((_event$length7 = event.length) === null || _event$length7 === void 0 ? void 0 : _event$length7.calendarEvent) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon calendarEvent"
    }), /*#__PURE__*/React.createElement("span", null, event.length.calendarEvent, " ", translate('Calendar events')))));
  }
  var indicator = function indicator() {
    if (!props.services.attendance) {
      return null;
    }
    var indicatorColor = "#DBDBDB";
    var text = translate("not-reported-lesson");
    if ((lesson === null || lesson === void 0 ? void 0 : lesson.linkedSchedulePositions) != null) {
      var reported = _toConsumableArray(lesson.linkedSchedulePositions.filter(function (lesson) {
        return lesson.attendanceReported != null;
      })).length;
      return /*#__PURE__*/React.createElement("div", {
        className: "status"
      }, /*#__PURE__*/React.createElement("span", {
        className: "indicator",
        style: {
          backgroundColor: reported == lesson.linkedSchedulePositions.length ? "#19DB6C" : "#DBDBDB"
        }
      }), reported, "(", lesson.linkedSchedulePositions.length, ")", " ", translate("reported"));
    }
    if (attendance != null) {
      indicatorColor = getAttendanceColor(attendance);
      if (attendance.attendanceType == "PRESENT") {
        text = translate("Present");
      } else if (attendance.attendanceType == "INVALID_ABSENCE") {
        text = translate("Invalid absent");
      } else if (attendance.attendanceType == "VALID_ABSENCE") {
        text = translate("Valid absent");
      } else if (attendance.attendanceType == "OTHER_ACTIVITY") {
        text = translate("OTHER_ACTIVITY");
      } else if (attendance.attendanceType == "INVALID_LATE") {
        text = translate("Partly invalid absent");
      } else if (attendance.attendanceType == "VALID_LATE") {
        text = translate("Partly absent");
      } else if (attendance.attendanceType == "OTHER_ACTIVITY_PARTIAL") {
        text = translate("OTHER_ACTIVITY_PARTIAL");
      }
    } else {
      if (lesson.attendanceReported != null) {
        indicatorColor = "#19DB6C";
        text = translate("reported");
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "status"
    }, /*#__PURE__*/React.createElement("span", {
      className: "indicator",
      style: {
        backgroundColor: indicatorColor
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "text"
    }, text));
  };
  if (props.view == "agenda" && lesson !== null && lesson !== void 0 && lesson.room && lesson.type === 'LESSON') {
    return /*#__PURE__*/React.createElement("div", {
      className: "event-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "agenda-event-title"
    }, event.title, (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement(Icon, {
      name: "Teams"
    }) : null), /*#__PURE__*/React.createElement("div", null, lesson.room), /*#__PURE__*/React.createElement("div", {
      className: "event-meta"
    }, lesson !== null && lesson !== void 0 && lesson.attendanceReported || attendance != null ? indicator() : " "));
  }
  if ((lesson === null || lesson === void 0 ? void 0 : lesson.length) >= 40 && lesson.type === 'LESSON') {
    return /*#__PURE__*/React.createElement("div", {
      className: "event-info"
    }, event.title, /*#__PURE__*/React.createElement("div", {
      className: "size-12 event-meta"
    }, lesson.attendanceReported || attendance != null || lesson.room == null ? indicator() : lesson.room), (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
      className: "teams-meeting-indicator"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Teams"
    })) : null);
  }
  return /*#__PURE__*/React.createElement("div", null, event === null || event === void 0 ? void 0 : event.title, (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
    className: "teams-meeting-indicator"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Teams"
  })) : null);
};
export default ItemContent;